import { getId } from "helpers/functions";
import {
  DELETE_OBJECTION,
  DELETE_OBJECTION_FAILURE,
  DELETE_OBJECTION_SUCCESS,
  GET_OBJECTIONS,
  GET_OBJECTIONS_FAILURE,
  GET_OBJECTIONS_SUCCESS,
  GET_SINGLE_OBJECTION,
  GET_SINGLE_OBJECTION_FAILURE,
  GET_SINGLE_OBJECTION_SUCCESS,
} from "./actionTypes";

const initialState = {
  objections: [],
  loading: false,
  error: "",
  singleObjection: {},
};

const objections = (state = initialState, action) => {
  switch (action.type) {
    case GET_OBJECTIONS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_OBJECTIONS_SUCCESS:
      state = {
        ...state,
        loading: false,
        objections: action.payload.objections,
      };
      break;
    case GET_OBJECTIONS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_OBJECTION:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_SINGLE_OBJECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleObjection: action.payload.objection,
      };
      break;

    case GET_SINGLE_OBJECTION_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
        singleObjection: {},
      };
      break;

    case DELETE_OBJECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_OBJECTION_SUCCESS:
      state = {
        ...state,
        loading: false,
        objections: state.objections.filter(
          (objection) => getId(objection) !== action.payload?.id
        ),
      };
      break;
    case DELETE_OBJECTION_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default objections;
